export default __webpack_public_path__ + "static/media/amazonLogo1.0ca53cd9.svg";